var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.e5baffb385cb6f2abd965aad62107117.svg#T';
                    var viewUrl = 'sprites.e5baffb385cb6f2abd965aad62107117.svg#view-T';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 22 21',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };